module.exports = __webpack_public_path__ + "img/tg5_title.abcbfb29.png";